import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["currentPage", "totalPages", "onPrev", "onNext", "onPageChange", "isDark", "dark", "isWhite", "white", "isTransparent", "className", "htmlProps"];
import { forwardRef } from 'react';
import cn from 'classnames';
import IconButton from "../../Buttons/IconButton";
import transition from "../../styles/transition";
import { DOTS_PAGINATION_THEMES } from "../themes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Dots = function Dots(_ref, ref) {
  var _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    _ref$totalPages = _ref.totalPages,
    totalPages = _ref$totalPages === void 0 ? 1 : _ref$totalPages,
    onPrev = _ref.onPrev,
    onNext = _ref.onNext,
    onPageChange = _ref.onPageChange,
    isDark = _ref.isDark,
    dark = _ref.dark,
    isWhite = _ref.isWhite,
    white = _ref.white,
    isTransparent = _ref.isTransparent,
    className = _ref.className,
    htmlProps = _ref.htmlProps,
    dotsPaginationProps = _objectWithoutProperties(_ref, _excluded);
  var onDotClicked = function onDotClicked(selectedPage) {
    if (typeof onPageChange === 'function') {
      onPageChange(selectedPage);
    }
  };
  var themeName = isDark || dark ? 'dark' : 'light';
  if (isTransparent) {
    themeName = 'transparent';
  }
  var theme = DOTS_PAGINATION_THEMES[themeName];
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: cn('flex items-center justify-between', className)
  }, dotsPaginationProps), htmlProps), {}, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      arrow: "left",
      className: theme.arrowLeftSpacingClassName,
      withoutBorders: true,
      customSize: themeName === 'transparent' ? 24 : 32,
      isDark: themeName !== 'light',
      isWhite: isWhite || white,
      disabled: currentPage <= 1,
      onClick: onPrev,
      "aria-label": "Atr\xE1s"
    }), /*#__PURE__*/_jsx("div", {
      className: "flex items-center",
      children: Array.from({
        length: totalPages
      }).map(function (_, i) {
        return /*#__PURE__*/_jsx("button", {
          type: "button",
          "aria-label": "Pag-".concat(i * 1),
          className: cn('rounded-full flex-shrink-0', theme.dot[i + 1 === currentPage ? 'active' : 'default'].sizeClassname, theme.dot[i + 1 === currentPage ? 'active' : 'default'].colorClassname),
          style: {
            transition: transition(['background-color', 'border'])
          },
          onClick: function onClick() {
            return onDotClicked(i + 1);
          }
        }, "pag-dot-".concat(i * 1));
      })
    }), /*#__PURE__*/_jsx(IconButton, {
      arrow: "right",
      className: theme.arrowRightSpacingClassName,
      withoutBorders: true,
      customSize: themeName === 'transparent' ? 24 : 32,
      isDark: themeName !== 'light',
      isWhite: isWhite || white,
      disabled: currentPage >= totalPages,
      onClick: onNext,
      "aria-label": "Adelante"
    })]
  }));
};
export default /*#__PURE__*/forwardRef(Dots);